import { ImageWrapper } from 'common/image/image-wrapper.js';
import { LinkFactoryReactRouter } from 'common/link/link-react-router.js';

interface IItem {
  title: string;
  url: string;
  image: string;
}

interface IImageTileCompactProps {
  items: IItem[];
}

export const ImageTileCompact = ({ items }: IImageTileCompactProps) => (
  <>
    {items.map(({ title, image, url }, index) => (
      <div data-comp="image-tile-compact-c" className="Tile" key={index}>
        <div className="Tile-body Tile-body--noPadding">
          <LinkFactoryReactRouter href={url} className="u-linkClean u-width1of1 u-block">
            <div className="u-flex u-flexAlignItemsCenter u-width1of1">
              <div className="u-width1of4">
                <ImageWrapper src={image} ratio="square" />
              </div>
              <div className="u-width3of4">
                <p className="u-mT-0 u-mB-0 u-mL-sm u-textBold u-textDefault">{title}</p>
              </div>
            </div>
          </LinkFactoryReactRouter>
        </div>
      </div>
    ))}
  </>
);
